
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as careerZtAdNTcsSJJmj9nwTKhdDAiT_Ve__SXtWLW_e_6dlPEMeta } from "/app/pages/career.vue?macro=true";
import { default as artistsYR9ed2ADnY5wsuf58AEgKWb1ljJKWqqr3pD2hgiRfqsMeta } from "/app/pages/artists.vue?macro=true";
import { default as booking33tFJxD50XdhLz_nPee8UtbBXk6Y5rw__45W3w4wkpB10Meta } from "/app/pages/booking.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as license0S52g6iTMruygl3iMmR_45S1dCtPUz64qZRjNPNxOipUAMeta } from "/app/pages/license.vue?macro=true";
import { default as articles4qJTG_45aAG7g49xw2jJsyZFUJKaYFnbvDXJD_45ryswoq8Meta } from "/app/pages/articles.vue?macro=true";
import { default as podcastsL2Ek7q0eOT9hcC4lgp0QRVpIFZmvVxnJjNbpvuVoNwEMeta } from "/app/pages/podcasts.vue?macro=true";
import { default as for_45mediavpKs0730QV1CgilFEsDhvpohN3o1UblJmqbfHqYhRRIMeta } from "/app/pages/for-media.vue?macro=true";
import { default as newsletterWvr_45ldoWfuImUOgsCqZIsZVFmncZcSS9UXn1BfhV83IMeta } from "/app/pages/newsletter.vue?macro=true";
import { default as for_45artists32KJlziej0LEPK4Xl2RpQrh499hIE3bSK_45UJMqgqBp8Meta } from "/app/pages/for-artists.vue?macro=true";
import { default as for_45businessG8bgsvBNhmV8Nmzv6rYgqct0bcPhqT6ZeYbsLNW6kIgMeta } from "/app/pages/for-business.vue?macro=true";
import { default as new_45releasesfimmp5GPDQnin_45fcDpPlDiLcqSjRs_9sgfw8KUEJJi8Meta } from "/app/pages/new-releases.vue?macro=true";
import { default as prague_45storeeqaDz8ncptwmrGAGN0yeIuQifWuK16dJw_qpF6dcAy4Meta } from "/app/pages/prague-store.vue?macro=true";
import { default as _91slug_93yvIo8_450Es8ecJQgWcqJDJATJhRhYMD_45p11a4xwiy_YoMeta } from "/app/pages/artist/[slug].vue?macro=true";
import { default as _91slug_93U5op66TpI1Wy1bT_18ioovhvTQqxBFGqaJdV_455BbBuYMeta } from "/app/pages/article/[slug].vue?macro=true";
import { default as _91slug_93RWSLV2POM_455KamHCWOojhlJegoR_45o0chccBe3Y_Zvu0Meta } from "/app/pages/podcast/[slug].vue?macro=true";
import { default as _91slug_93ThYOVAk1GMNeZIuI41xfWpiBxx1TBm0ScZxGXKly69wMeta } from "/app/pages/release/[slug].vue?macro=true";
import { default as index_BtZx_BuRAWbPHJ1TDooC6dGVYepRF6yutT5tG2_smAMeta } from "/app/pages/album/[slug]/index.vue?macro=true";
import { default as story_45of_45supraphonXDtd2hBt_l64ChpIBZ5ShXSJXNpl1D3KyF_9fmqBCqkMeta } from "/app/pages/story-of-supraphon.vue?macro=true";
import { default as _91audio_93fJxV1WeHGWtjMPOSR1KAPHkAZCGUevCyrDOhKQx1k7gMeta } from "/app/pages/album/[slug]/[audio].vue?macro=true";
import { default as influencer_45marketingC5gD_CMtN06fcwIngbMwcqc5rhM6zuPYIenj9xgaM4MMeta } from "/app/pages/influencer-marketing.vue?macro=true";
import { default as information_45on_45the_45book_45entry_45of_45sharesUdidRfmoqsHy9Zt2lI3IZIbKjgLNRla2AZUQACVIEv0Meta } from "/app/pages/information-on-the-book-entry-of-shares.vue?macro=true";
export default [
  {
    name: "index___cs",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug___cs",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "career___cs",
    path: "/kariera",
    component: () => import("/app/pages/career.vue")
  },
  {
    name: "career___en",
    path: "/en/career",
    component: () => import("/app/pages/career.vue")
  },
  {
    name: "artists___cs",
    path: "/umelci",
    component: () => import("/app/pages/artists.vue")
  },
  {
    name: "artists___en",
    path: "/en/artists",
    component: () => import("/app/pages/artists.vue")
  },
  {
    name: "booking___cs",
    path: "/booking",
    component: () => import("/app/pages/booking.vue")
  },
  {
    name: "booking___en",
    path: "/en/booking",
    component: () => import("/app/pages/booking.vue")
  },
  {
    name: "contact___cs",
    path: "/kontakty",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact-us",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "license___cs",
    path: "/licence",
    component: () => import("/app/pages/license.vue")
  },
  {
    name: "license___en",
    path: "/en/licensing",
    component: () => import("/app/pages/license.vue")
  },
  {
    name: "articles___cs",
    path: "/novinky",
    component: () => import("/app/pages/articles.vue")
  },
  {
    name: "articles___en",
    path: "/en/news",
    component: () => import("/app/pages/articles.vue")
  },
  {
    name: "podcasts___cs",
    path: "/podcasty",
    component: () => import("/app/pages/podcasts.vue")
  },
  {
    name: "podcasts___en",
    path: "/en/podcasts",
    component: () => import("/app/pages/podcasts.vue")
  },
  {
    name: "for-media___cs",
    path: "/pro-media",
    component: () => import("/app/pages/for-media.vue")
  },
  {
    name: "for-media___en",
    path: "/en/for-media",
    component: () => import("/app/pages/for-media.vue")
  },
  {
    name: "newsletter___cs",
    path: "/newsletter",
    component: () => import("/app/pages/newsletter.vue")
  },
  {
    name: "newsletter___en",
    path: "/en/newsletter",
    component: () => import("/app/pages/newsletter.vue")
  },
  {
    name: "for-artists___cs",
    path: "/pro-umelce",
    component: () => import("/app/pages/for-artists.vue")
  },
  {
    name: "for-artists___en",
    path: "/en/for-artists",
    component: () => import("/app/pages/for-artists.vue")
  },
  {
    name: "for-business___cs",
    path: "/pro-obchodniky",
    component: () => import("/app/pages/for-business.vue")
  },
  {
    name: "for-business___en",
    path: "/en/for-retailers",
    component: () => import("/app/pages/for-business.vue")
  },
  {
    name: "new-releases___cs",
    path: "/prave-vychazi",
    component: () => import("/app/pages/new-releases.vue")
  },
  {
    name: "new-releases___en",
    path: "/en/new-releases",
    component: () => import("/app/pages/new-releases.vue")
  },
  {
    name: "prague-store___cs",
    path: "/prodejna",
    component: () => import("/app/pages/prague-store.vue")
  },
  {
    name: "prague-store___en",
    path: "/en/prague-store",
    component: () => import("/app/pages/prague-store.vue")
  },
  {
    name: "artist-slug___cs",
    path: "/umelci/:slug()",
    component: () => import("/app/pages/artist/[slug].vue")
  },
  {
    name: "artist-slug___en",
    path: "/en/artists/:slug()",
    component: () => import("/app/pages/artist/[slug].vue")
  },
  {
    name: "article-slug___cs",
    path: "/novinky/:slug()",
    component: () => import("/app/pages/article/[slug].vue")
  },
  {
    name: "article-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/app/pages/article/[slug].vue")
  },
  {
    name: "podcast-slug___cs",
    path: "/podcasty/:slug()",
    component: () => import("/app/pages/podcast/[slug].vue")
  },
  {
    name: "podcast-slug___en",
    path: "/en/podcasts/:slug()",
    component: () => import("/app/pages/podcast/[slug].vue")
  },
  {
    name: "release-slug___cs",
    path: "/prave-vychazi/:slug()",
    component: () => import("/app/pages/release/[slug].vue")
  },
  {
    name: "release-slug___en",
    path: "/en/new-releases/:slug()",
    component: () => import("/app/pages/release/[slug].vue")
  },
  {
    name: "album-slug___cs",
    path: "/album/:slug()",
    component: () => import("/app/pages/album/[slug]/index.vue")
  },
  {
    name: "album-slug___en",
    path: "/en/album/:slug()",
    component: () => import("/app/pages/album/[slug]/index.vue")
  },
  {
    name: "story-of-supraphon___cs",
    path: "/pribeh-supraphonu",
    component: () => import("/app/pages/story-of-supraphon.vue")
  },
  {
    name: "story-of-supraphon___en",
    path: "/en/story-of-supraphon",
    component: () => import("/app/pages/story-of-supraphon.vue")
  },
  {
    name: "album-slug-audio___cs",
    path: "/alba/:slug()/:audio()",
    component: () => import("/app/pages/album/[slug]/[audio].vue")
  },
  {
    name: "album-slug-audio___en",
    path: "/en/albums/:slug()/:audio()",
    component: () => import("/app/pages/album/[slug]/[audio].vue")
  },
  {
    name: "influencer-marketing___cs",
    path: "/influencer-marketing",
    component: () => import("/app/pages/influencer-marketing.vue")
  },
  {
    name: "influencer-marketing___en",
    path: "/en/influencer-marketing",
    component: () => import("/app/pages/influencer-marketing.vue")
  },
  {
    name: "information-on-the-book-entry-of-shares___cs",
    path: "/informace-o-zaknihovani-akcii",
    component: () => import("/app/pages/information-on-the-book-entry-of-shares.vue")
  },
  {
    name: "information-on-the-book-entry-of-shares___en",
    path: "/en/information-on-the-book-entry-of-shares",
    component: () => import("/app/pages/information-on-the-book-entry-of-shares.vue")
  }
]